var _excluded = ["extension", "hideOriginalOutline", "hideOriginalShadow"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var focusRing = function focusRing(theme) {
  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
  var extension = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  return {
    ':focus-visible': {
      outline: 'none',
      [extension]: {
        outlineStyle: 'solid',
        outlineWidth: "".concat(size, "px"),
        outlineOffset: "".concat(offset, "px"),
        outlineColor: theme.color.focus.default
      }
    }
  };
};
export var focusRingStyle = _ref => {
  var {
    theme,
    outlineSize = 2,
    outlineOffset = 2,
    shadowSize = 0,
    shadowInset = false
  } = _ref;
  return {
    boxShadow: "0px 0px 0px  ".concat(shadowSize, "px ").concat(theme.color.focus.inverse, " ").concat(shadowInset ? 'inset' : ''),
    outlineStyle: 'solid',
    outlineWidth: "".concat(outlineSize, "px"),
    outlineOffset: "".concat(outlineOffset, "px"),
    outlineColor: theme.color.focus.default
  };
};
export var doubleFocusRing = _ref2 => {
  var {
      extension = '',
      hideOriginalOutline = false,
      hideOriginalShadow = false
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded);
  return {
    ':focus-visible': _objectSpread(_objectSpread(_objectSpread({}, hideOriginalOutline && {
      outline: 'none'
    }), hideOriginalShadow && {
      boxShadow: 'none'
    }), {}, {
      [extension]: _objectSpread({}, focusRingStyle(props))
    })
  };
};
export default focusRing;
export var hideFocusRing = () => ({
  ':focus-visible': {
    outline: 'none'
  }
});